import { computed, Directive, input } from '@angular/core';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';

@Directive({
  selector: 'brn-switch-thumb[hlm],[hlmSwitchThumb]',
  host: {
    '[class]': '_computedClass()',
  },
})
export class HlmSwitchThumb {
  public readonly userClass = input<ClassValue>('', { alias: 'class' });

  protected readonly _computedClass = computed(() =>
    hlm(
      'bg-components-content-neutral-primary-reversed pointer-events-none block size-[20px] rounded-full ring-0 transition-transform group-data-[state=checked]:translate-x-[calc(100%-2px)] group-data-[state=unchecked]:translate-x-[2px]',
      this.userClass(),
    ),
  );
}
